export default "__VITE_ASSET__CgjrR6vP__"